
import { RevButtonTiny } from '@ds/components/ButtonTiny'
import { RevLink } from '@ds/components/Link'
import { IconCross } from '@ds/icons/IconCross'
import uniqBy from 'lodash/uniqBy'
import { mapGetters } from 'vuex'

import { trackClick } from '@tracking/events'

import {
  FACET_PAGE,
  FACET_PRICE,
  FACET_QUERY,
  FACET_SORT,
} from '../../../utils/algolia'

import translations from './ActiveFilters.translations'

export default {
  components: {
    RevButtonTiny,
    RevLink,
  },
  props: {
    filters: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      facets: 'landingSearch/facets',
      searchNbResults: 'landingSearch/nbResults',
    }),

    IconCross: () => IconCross,
    translations: () => translations,

    // We show the clear all button for all selected values, except page, sort & query.
    // Note that for price, we don't display any other specific button than the clear all
    showClearButtons() {
      return !!Object.keys(this.filters).filter(
        (filter) => ![FACET_PAGE, FACET_SORT, FACET_QUERY].includes(filter),
      ).length
    },

    filteredFacets() {
      return uniqBy(this.facets, 'facetName')
    },

    removableValues() {
      return (
        Object.keys(this.filters)
          // Let's remove page, sort, search query and price facets as we don't do anything with those
          .filter(
            (filter) =>
              ![FACET_PAGE, FACET_SORT, FACET_QUERY, FACET_PRICE].includes(
                filter,
              ),
          )
          // Let's format the data to get an array of { facet, value, label }
          .reduce(
            (values, facet) => [
              ...values,
              ...this.filters[facet]
                .map((value) => {
                  const label =
                    this.filteredFacets
                      .find(({ facetName }) => facetName === facet)
                      ?.facetValues.find(
                        ({ facet_value }) => facet_value === value,
                      )?.label ?? undefined

                  // If the value is not found (for instance, by adding a random one in the hash like
                  // &brand=doesnotexist), we ignore it.
                  if (!label) {
                    return undefined
                  }

                  return {
                    facet,
                    value,
                    label,
                  }
                })
                .filter((value) => !!value),
            ],
            [],
          )
      )
    },
  },
  methods: {
    onReset() {
      trackClick({
        name: 'clear_filter',
        zone: 'product list > side filter',
        value: 'clear all filters',
      })

      this.$emit('reset')
    },

    onRemoveFilter({ facet, value }) {
      trackClick({
        name: 'clear_filter',
        zone: 'product list > side filter',
        value: facet,
      })

      this.$emit('change', {
        [facet]: this.filters[facet].filter((val) => val !== value),
      })
    },
  },
}
